import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"margin":"0 auto"},
  class: "p-fluid p-grid p-col-12 p-formgrid"
}
const _hoisted_2 = { class: "p-field p-col-12 p-md-3 p-2" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-3 p-2" }
const _hoisted_4 = {
  key: 0,
  class: "p-field p-col-12 p-md-4 p-2"
}
const _hoisted_5 = { class: "p-col-1" }
const _hoisted_6 = {
  key: 0,
  class: "p-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_p_calender = _resolveComponent("p-calender")!
  const _component_p_multiselect = _resolveComponent("p-multiselect")!
  const _component_p_button = _resolveComponent("p-button")!
  const _component_DSEDashboard = _resolveComponent("DSEDashboard")!
  const _component_ManagerDashboard = _resolveComponent("ManagerDashboard")!
  const _component_RSMDashboard = _resolveComponent("RSMDashboard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("label", null, "Start Date", -1)),
        _createVNode(_component_p_calender, {
          placeholder: "dd/mm/yyyy",
          modelValue: _ctx.start_time,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.start_time) = $event)),
          dateFormat: "dd/mm/yy",
          showIcon: true,
          onDateSelect: _ctx.refresh,
          onInput: _ctx.refresh,
          showButtonBar: "",
          showOnFocus: false
        }, null, 8, ["modelValue", "onDateSelect", "onInput"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("label", null, "End Date", -1)),
        _createVNode(_component_p_calender, {
          placeholder: "dd/mm/yyyy",
          modelValue: _ctx.end_time,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.end_time) = $event)),
          dateFormat: "dd/mm/yy",
          showIcon: true,
          showButtonBar: "",
          onDateSelect: _ctx.refresh,
          onInput: _ctx.refresh,
          showOnFocus: false
        }, null, 8, ["modelValue", "onDateSelect", "onInput"])
      ]),
      (_ctx.isManager || _ctx.isRSM)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("label", null, "Usernames", -1)),
            _createVNode(_component_p_multiselect, {
              filter: true,
              onChange: _ctx.filterManager,
              modelValue: _ctx.selectedUsernames,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedUsernames) = $event)),
              options: _ctx.usernames,
              placeholder: "Select users",
              display: "chip"
            }, null, 8, ["onChange", "modelValue", "options"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_p_button, {
          icon: "pi pi-refresh",
          onClick: _ctx.refresh,
          rounded: "",
          raised: ""
        }, null, 8, ["onClick"])
      ])
    ]),
    (_ctx.dashboard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (!_ctx.isManager && !_ctx.isRSM)
            ? (_openBlock(), _createBlock(_component_DSEDashboard, {
                key: 0,
                report: _ctx.dashboard,
                onAttendanceChanged: _ctx.refresh
              }, null, 8, ["report", "onAttendanceChanged"]))
            : (_ctx.isManager)
              ? (_openBlock(), _createBlock(_component_ManagerDashboard, {
                  key: 1,
                  reports: _ctx.filtered
                }, null, 8, ["reports"]))
              : (_ctx.isRSM)
                ? (_openBlock(), _createBlock(_component_RSMDashboard, {
                    key: 2,
                    reports: _ctx.filtered
                  }, null, 8, ["reports"]))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}